import { entityKeyOf } from '@platform/core/lib/modulePaths';
import { routes } from '@platform/core/lib/routes';
import { isRecordSegment } from '@platform/navigation/routeKeys';

/**
 * Чи адреса — «подання модуля» прототипу v4 (стан page:'module', до якого повертає крихта модуля): список головного типу в будь-якому
 * поданні й пункті меню або сторінка модуля (огляд, поради, аналітика, довідка, аналітичне подання). Запис, дочірня таблиця (окремий
 * модуль прототипу), налаштування й проєктування — ні. Сегменти — за схемою ADR-028 (`/<група>/<модуль>/<сутність | сторінка>/…`). Чиста функція.
 */
export function isModuleView(pathname: string, moduleKey: string, mainKey: string): boolean {
  if (!pathname.startsWith(`${routes.module(moduleKey)}/`)) return false;
  const [, , , segment, sub] = pathname.split('/');
  if (!segment || segment === 'settings' || segment === 'design') return false;
  const rt = entityKeyOf(moduleKey, segment);
  return rt ? rt === mainKey && !(sub && isRecordSegment(sub)) : true;
}
